import styled from "styled-components";
import { useTranslation } from "@pancakeswap/localization";
import { Text } from "../../../../components/Text";
import { HelpIcon } from "../../../../components/Svg";
import { Skeleton } from "../../../../components/Skeleton";
import { useTooltip } from "../../../../hooks/useTooltip";
import { FarmTableLiquidityProps } from "../../types";

const ReferenceElement = styled.div<React.HTMLAttributes<HTMLDivElement> & { ref?: any }>`
  display: inline-block;
`;

const LiquidityWrapper = styled.div<React.HTMLAttributes<HTMLDivElement> & { ref?: any }>`
  min-width: 110px;
  font-weight: 600;
  text-align: right;
  margin-right: 14px;

  ${({ theme }) => theme.mediaQueries.lg} {
    text-align: left;
    margin-right: 0;
  }
`;

const Container = styled.div<React.HTMLAttributes<HTMLDivElement> & { ref?: any }>`
  display: flex;
  align-items: center;
`;

const Liquidity: React.FunctionComponent<React.PropsWithChildren<FarmTableLiquidityProps>> = ({ liquidity }) => {
  const displayLiquidity =
    liquidity && liquidity.gt(0) ? (
      `$${Number(liquidity).toLocaleString(undefined, { maximumFractionDigits: 0 })}`
    ) : (
      <Skeleton width={60} />
    );
  const { t } = useTranslation();
  const { targetRef, tooltip, tooltipVisible } = useTooltip(
    t("Total value of the funds in this farm’s liquidity pool"),
    { placement: "top-end", tooltipOffset: [20, 10] }
  );

  return (
    <Container>
      <LiquidityWrapper>
        <Text>{displayLiquidity}</Text>
      </LiquidityWrapper>
      <ReferenceElement ref={targetRef}>
        <HelpIcon color="textSubtle" />
      </ReferenceElement>
      {tooltipVisible && tooltip}
    </Container>
  );
};

export default Liquidity;
